// extracted by mini-css-extract-plugin
export default {"dropdown-width":"ControlStatementDropdown_dropdown-width__fig6a","label-style":"ControlStatementDropdown_label-style__rkquC"};